<template>
  <div class="card card-custom gutter-b">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title">
        <h3 class="card-label">Danh sách kết quả học viên</h3>
      </div>
      <div class="card-title">
        <button
          type="button"
          class="btn btn-light-primary font-weight-bolder mr-2"
          :disabled="is_disable_export"
          @click="handleExport"
        >
          <span class="svg-icon svg-icon-md"><i class="el-icon-download"></i></span> Export
        </button>
        <button type="button" class="btn btn-light-success font-weight-bolder" @click="handleCreate">
          <i class="fa fa-plus mr-1"></i> Thêm mới
        </button>
      </div>
    </div>

    <div class="card-body">
      <div class="example mb-10">
        <div class="row align-items-end">
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-5">
            <label>Học viên</label>
            <el-input
              v-model="query.student_keyword"
              class="w-100"
              placeholder="Tìm tên, số điện thoại"
              clearable
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-5">
            <label>Thời gian thi</label>
            <date-picker
              v-model="query.exam_times"
              class="w-100"
              type="date"
              format="DD-MM-YYYY"
              value-type="YYYY-MM-DD"
              range
              placeholder="Chọn thời gian thi"
              @change="handleExamTimeChange"
            />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-5">
            <label>Thời gian tạo</label>
            <date-picker
              v-model="query.created_ats"
              class="w-100"
              type="date"
              format="DD-MM-YYYY"
              value-type="YYYY-MM-DD"
              range
              placeholder="Chọn thời gian tạo"
              @change="handleCreatedAtChange"
            />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-5">
            <button type="button" class="btn btn-primary" :disabled="loading" @click="searchData">
              <i class="el-icon-search mr-1"></i> Tìm kiếm
            </button>
          </div>
        </div>

        <div class="example-preview table-responsive overflow-auto mt-8 position-relative">
          <table
            class="table table-hover table-bordered table-vertical-center b-table"
            style="text-align: center; table-layout: fixed;"
          >
            <thead>
              <tr>
                <th style="width: 180px;">Học viên</th>
                <th style="width: 140px;">Loại</th>
                <th style="width: 80px;">Listening</th>
                <th style="width: 80px;">Reading</th>
                <th style="width: 80px;">Writing</th>
                <th style="width: 80px;">Speaking</th>
                <th style="width: 80px;">Vocab</th>
                <th style="width: 80px;">Overall</th>
                <th style="width: 160px;">Thời gian thi</th>
                <th style="width: 160px;">Thời gian tạo</th>
                <th style="width: 120px;">Hành động</th>
              </tr>
            </thead>
            <tbody v-if="loading">
              <tr>
                <td colspan="11">
                  <div class="text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Loading...</strong>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="item in resultList" :key="`${item.exam_type}-${item.id}`">
                <td style="word-wrap: break-word; overflow-wrap: break-word;">
                  {{ item.student_name }} - {{ item.phone }}
                </td>
                <td>{{ item.exam_type }}</td>
                <td>{{ item.listening }}</td>
                <td>{{ item.reading }}</td>
                <td>{{ item.writing }}</td>
                <td>{{ item.speaking }}</td>
                <td>{{ item.vocab }}</td>
                <td>{{ item.overall }}</td>
                <td>{{ formatDateTime(item.exam_time) }}</td>
                <td>{{ formatDateTime(item.created_at) }}</td>
                <td>
                  <template v-if="canShowActions(item)">
                    <el-tooltip content="Sửa">
                      <button class="btn btn-icon btn-xs btn-outline-primary mr-2" @click="handleEdit(item)">
                        <i class="el-icon-edit"></i>
                      </button>
                    </el-tooltip>
                    <el-tooltip content="Xem chi tiết">
                      <button class="btn btn-icon btn-xs btn-outline-info" @click="handleView(item)">
                        <i class="fa fa-file-alt"></i>
                      </button>
                    </el-tooltip>
                  </template>
                </td>
              </tr>
              <tr v-if="resultList.length === 0">
                <td colspan="11" class="event-title no-data">Không có dữ liệu</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-end align-items-center mt-3">
          <div class="text-right">
            Tổng số bản ghi: <b class="text-primary">{{ total }}</b>
          </div>
        </div>
      </div>
    </div>

    <div class="edu-paginate mx-auto text-center">
      <paginate
        v-model="page"
        :page-count="last_page"
        :page-range="3"
        :margin-pages="1"
        :click-handler="clickCallback"
        :prev-text="'Trước'"
        :next-text="'Sau'"
        :container-class="'pagination b-pagination'"
        :page-link-class="'page-link'"
        :next-link-class="'next-link-item'"
        :prev-link-class="'prev-link-item'"
        :prev-class="'page-link'"
        :next-class="'page-link'"
        :page-class="'page-item'"
      />
    </div>

    <StudentExamResultFormModal
      :visible.sync="formModalVisible"
      :mode="formMode"
      :record="selectedRecord"
      @saved="fetchList"
    />

    <StudentExamResultHistoryModal
      :visible="historyModalVisible"
      :record="historyRecord"
      :data="historyData"
      :loading="historyLoading"
      @close="closeHistoryModal"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module';
import { exportExcel, HEADER_ROW_EXPORT_ENTRANCE_STUDENT_RESULT } from '@/core/filters';
import {
  ENTRANCE_STUDENT_RESULT_LIST,
  ENTRANCE_STUDENT_RESULT_EXPORT,
  ENTRANCE_STUDENT_RESULT_HISTORY,
} from '@/core/services/store/entrance/entrance.module';
import StudentExamResultFormModal from '@/view/pages/entrance-manage/components/StudentExamResultFormModal.vue';
import StudentExamResultHistoryModal from '@/view/pages/entrance-manage/components/StudentExamResultHistoryModal.vue';

export default {
  name: 'StudentExamResultList',
  components: {
    DatePicker,
    StudentExamResultFormModal,
    StudentExamResultHistoryModal,
  },
  data() {
    return {
      query: {
        student_keyword: '',
        exam_times: [],
        created_ats: [],
      },
      resultList: [],
      loading: false,
      is_disable_export: false,
      page: 1,
      perPage: 20,
      last_page: 1,
      total: 0,
      formModalVisible: false,
      formMode: 'create',
      selectedRecord: null,
      historyModalVisible: false,
      historyRecord: null,
      historyData: [],
      historyLoading: false,
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Thi đầu khóa', route: '' },
      { title: 'Danh sách kết quả học viên', route: '' },
    ]);
    this.fetchList();
  },
  methods: {
    handleExamTimeChange(value) {
      this.query.exam_times = this.normalizeDateRange(value);
    },
    handleCreatedAtChange(value) {
      this.query.created_ats = this.normalizeDateRange(value);
    },
    normalizeDateRange(value) {
      if (Array.isArray(value) && value.length === 2 && value[0] === null && value[1] === null) {
        return [];
      }
      return value || [];
    },
    searchData() {
      this.page = 1;
      this.fetchList();
    },
    clickCallback(page) {
      this.page = page;
      this.fetchList();
    },
    formatDateTime(value) {
      if (!value) return '';
      return moment(value).format('HH:mm:ss DD/MM/YYYY');
    },
    isTestInput(item) {
      return item.exam_type === 'Test đầu vào';
    },
    canShowActions(item) {
      return !this.isTestInput(item);
    },
    async handleExport() {
      this.is_disable_export = true;
      let data_export;
      try {
        const res = await this.$store.dispatch(ENTRANCE_STUDENT_RESULT_EXPORT, this.query);
        data_export = res.data;
        exportExcel(
          HEADER_ROW_EXPORT_ENTRANCE_STUDENT_RESULT,
          data_export,
          'Danh sách kết quả học viên.xlsx',
          false
        );
        this.$message.success('Xuất dữ liệu thành công');
      } catch (error) {
        console.error('Export error:', error);
        this.$message.error('Không thể xuất được dữ liệu');
      } finally {
        this.is_disable_export = false;
      }
    },
    handleCreate() {
      this.formMode = 'create';
      this.selectedRecord = null;
      this.formModalVisible = true;
    },
    handleEdit(item) {
      this.formMode = 'edit';
      this.selectedRecord = { ...item };
      this.formModalVisible = true;
    },
    async handleView(item) {
      this.historyRecord = item;
      this.historyModalVisible = true;
      this.historyLoading = true;
      this.historyData = [];
      try {
        const res = await this.$store.dispatch(ENTRANCE_STUDENT_RESULT_HISTORY, item.id);
        this.historyData = res.data ?? [];
      } catch (error) {
        this.$message.error(error?.message || 'Không thể tải lịch sử');
        this.historyModalVisible = false;
      } finally {
        this.historyLoading = false;
      }
    },
    closeHistoryModal() {
      this.historyModalVisible = false;
      this.historyRecord = null;
      this.historyData = [];
    },
    async fetchList() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch(ENTRANCE_STUDENT_RESULT_LIST, {
          ...this.query,
          page: this.page,
          per_page: this.perPage,
        });
        this.resultList = response.data;
        this.last_page = response.pagination.last_page;
        this.total = response.pagination.total;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.el-input,
.el-select {
  width: 100%;
}
</style>
